import { MAIN_URL, REQUEST_URL } from "../../constant/ApplicationVariables";
import { axiosInstance } from "../useAxios/useAxios";

// const axiosInstance = axiosInstance;

export const getAutomationFilesList_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.automationFilesList,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const getAutomationFileContent_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.automationFileContent,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const addAutomationFile_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.automationFiles,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const updateAutomationFile_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.automationFiles,
      method: "PUT",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const deleteAutomationFile_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.automationFiles,
      method: "DELETE",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const automationExecute_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.automationExecute,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const getMachinesList_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.devices,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const addAutomationFilesBulk_API = async (formData) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.automationFilesBulk,
      method: "POST",
      data: formData,
    });
    console.log(response, "addAutomationFilesBulk_API response");
    return response;
  } catch (error) {
    console.log(error, "addAutomationFilesBulk_API error");
    return error;
  }
};

export const generateBoundaryValues_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.generateBoundaryValues,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "generateBoundaryValues_API response");
    return response;
  } catch (error) {
    console.log(error, "generateBoundaryValues_API error");
    return error;
  }
};

export const getBoundaryCategories_API = async () => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.boundaryCategories,
      method: "GET",
      contentType: "application/json",
    });
    console.log(response, "getBoundaryCategories_API response");
    return response;
  } catch (error) {
    console.log(error, "getBoundaryCategories_API error");
    return error;
  }
};

export const fetchBoundaryValues_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.fetchBoundaryValues,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "fetchBoundaryValues_API response");
    return response;
  } catch (error) {
    console.log(error, "fetchBoundaryValues_API error");
    return error;
  }
};

export const updateBoundaryValues_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.updateBoundaryValues,
      method: "PUT",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "updateBoundaryValues_API response");
    return response;
  } catch (error) {
    console.log(error, "updateBoundaryValues error");
    return error;
  }
};

export const fetchFieldNames_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.fetchFieldNames,
      method: "POST",
      data: body,
    });
    return response.data;
  } catch (error) {
    console.log(error, "fetchFieldNames_API error");
    throw error;
  }
};
